import React, { useState } from 'react';
import { Modal, TextField, Button, Typography, Grid, Box } from '@mui/material';

interface CreateTypeModalProps {
  open: boolean;
  onClose: () => void;
  onCreate: (newType: string) => void;
}

const CreateTypeModal: React.FC<CreateTypeModalProps> = ({
  open,
  onClose,
  onCreate
}) => {
  const [newType, setNewType] = useState('');
  const [error, setError] = useState('');

  const handleCreate = () => {
    if (!newType.trim()) {
      setError('New Type is required');
    } else {
      onCreate(newType);
      setNewType('');
      setError('');
      onClose();
    }
  };

  const handleClose = () => {
    setNewType('');
    setError('');
    onClose();
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    p: 3,
    borderRadius: 2,
    boxShadow: 24,
    width: { xs: 300, sm: 400, lg: 500 },
    border: 'none',
    outline: 'none',
    '&:focus': {
      outline: 'none'
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Create New Type
            </Typography>
            <TextField
              label="New Type"
              fullWidth
              value={newType}
              onChange={(e) => setNewType(e.target.value)}
              margin="normal"
              error={!!error}
              helperText={error}
              required
            />
          </Grid>

          <Grid item xs={6}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              fullWidth
            >
              Close
            </Button>
          </Grid>

          <Grid item xs={6}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreate}
              fullWidth
            >
              Create
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CreateTypeModal;
